<template>
  <div class="slideshow-component" ref="component">
    <figure
      v-for="image, index in images"
      :class="{show: index === 0}"
      :style="{
        background: `url(${require(`@/assets/${image}`)}) no-repeat center center`,
        'animation': `${keyframeName} ${slideshowDuration}s linear infinite 0s`,
        'animation-delay': `${index * period}s`,
      }"
    />
  </div>
</template>
<script>
  export default {
    name: 'slideshow-component',
    props: ['images', 'height'],
    data() {
      return {
        currentIndex: 0,
        period: 4, // in seconds
      }
    },
    computed: {
      slideshowDuration() {
        return this.period * this.images.length
      },
      keyframeName() {
        if (this.images.length < 3 || this.images.length > 4) {
          console.error(`Cannot animate slideshow with ${this.images.length} images`)
        }
        return `slideShow${this.images.length}`
      },
    },
    mounted() {
      window.addEventListener('resize', this.centerImage)
      this.centerImage()
      this.$refs.component.style.height = `${this.height}px`
      this.prefetchImages()
    },
    destroyed() {
      window.removeEventListener('resize', this.centerImage)
    },
    methods: {
      prefetchImages() {
        for (const image in this.images) {
          const img = new Image
          img.src = image
        }
      },
      centerImage() {
        const imgs = this.$refs.component.getElementsByTagName('figure')
        for (const img of imgs) {
          img.style.minHeight = `${this.height}px`
          if (img.height < this.height) {
            img.style.marginTop = 'auto'
          } else {
            img.style.marginTop = `${(this.height - img.height) / 2}px`
          }
        }
      },
    },
  }
</script>
<style scoped lang="scss">
  .slideshow-component {
    overflow: hidden;
    position: relative;
    background: #f0f0f0;
    figure {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      opacity: 0;
      margin: 0;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      background-size: cover;
      &.show {
        opacity: 1;
      }
    }
  }


</style>